exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link-3ACgb {\n  padding-right: 15px;\n}\n.link-3ACgb, .link-3ACgb:link, .link-3ACgb:visited, .link-3ACgb:hover, .link-3ACgb:focus, .link-3ACgb:active {\n  color: #383838;\n}", ""]);

// Exports
exports.locals = {
	"link": "link-3ACgb"
};